<template>
  <el-config-provider :locale="locale">

      <router-view />

  </el-config-provider>
</template>
<script>
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'

// import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import zhCn from "element-plus/es/locale/lang/zh-cn";


export default defineComponent({
  components: {
    ElConfigProvider,
  },
  setup() {
    // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",import.meta.env.VITE_ENV) // 123
    return {
      locale: zhCn,
    }
  },
})
</script>
<style>
</style>
